import { ErrorMessage } from '@hookform/error-message'
import { confirmPasswordReset, verifyPasswordResetCode } from 'firebase/auth'
import { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { auth } from '../../../firebase'
import { ResetMiUser } from '../../../models/miModel'
import { LoginPath } from '../../../routes/path'
import { requestState } from '../../../states/atoms'
import { StyleFormHead } from '../../../styles/mi'
import { Button } from '../../Button'
import { HelperText } from '../../HelperText'
import { Input } from '../Input'

export const ResetPasswordSection: FC = () => {
  const query = new URLSearchParams(useLocation().search)
  const oobCode = query.get('oobCode') || ''
  const setRequestState = useSetRecoilState(requestState)

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<ResetMiUser>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { email: '', password: '' },
  })

  const submitNewPassword = async (data: ResetMiUser) => {
    setRequestState({ isLoading: true })
    try {
      await verifyPasswordResetCode(auth, oobCode)
    } catch (error) {
      setRequestState({
        isLoading: false,
        errorMessage: `認証に失敗しました。\n時間を置いて再度お試しください。`,
      })
      return
    }

    try {
      await confirmPasswordReset(auth, oobCode, data.password)
      setRequestState({
        isLoading: false,
        completeMessage: `パスワードの再設定が完了しました。\nログインを検証してください。`,
      })
      setTimeout(() => {
        location.href = LoginPath
      }, 1 * 1000)
    } catch (error) {
      setRequestState({
        isLoading: false,
        errorMessage: `パスワードが再設定できませんでした。\n時間を置いて再度お試しください。`,
      })
    }
  }

  if (!oobCode) {
    location.href = LoginPath
    return (
      <>
        <Container className="containerBase"></Container>
      </>
    )
  }

  return (
    <>
      <div className="containerBase">
        <Container>
          <form onSubmit={handleSubmit(submitNewPassword)} className="miForm">
            <Row>
              <StyleFormHead>
                <img src="/images/miproteger-logo.png" alt="" />
                <p>パスワード再設定</p>
              </StyleFormHead>
            </Row>
            <Row>
              <hr className="solid"></hr>
            </Row>

            <Row>
              <Col className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="password"
                  render={({ message }) => <HelperText>*{message}</HelperText>}
                />
                <Input
                  type="password"
                  placeholder="パスワード（8~16文字）"
                  isError={!!errors.password}
                  {...register('password', {
                    required: 'パスワードは必須です（8~16文字）',
                    pattern: {
                      value: /^[!-~]{8,16}$/,
                      message: '8~16文字で入力してください',
                    },
                  })}
                />
              </Col>
            </Row>
            <Row>
              <Col className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="passwordConfirmation"
                  render={({ message }) => <HelperText>*{message || 'パスワードが一致していません'}</HelperText>}
                />
                <Input
                  type="password"
                  placeholder="パスワード（確認）"
                  isError={!!errors.passwordConfirmation}
                  {...register('passwordConfirmation', {
                    required: 'パスワード（確認）は必須です',
                    validate: (value) => value === getValues('password'),
                  })}
                />
              </Col>
            </Row>

            <Row>
              <Col className="button">
                <Button
                  buttonType="contained"
                  isSubmit
                  onClick={() => undefined}
                  disabled={!!Object.keys(errors).length}
                  isFullWidth
                >
                  設定してログイン
                </Button>
              </Col>
            </Row>
          </form>
        </Container>
      </div>
    </>
  )
}
